import type * as React from 'react';

export interface BottomSheetAnimatedProps extends React.HTMLProps<HTMLAnchorElement> {
    /** ID, optional, when the bottomsheet is to be mounted on a separate portal. */
    id: string;
    /** Show the bottomsheet. */
    open?: boolean;
    /** Duck the bottomsheet for navigating into another view, but don't close it. */
    ducked?: boolean;
    /** Set to true only when the bottomsheet is created imperatively using showBottomsheet(). */
    imperative?: boolean;
    /** Custom callback to invoke on clicking the overlay. Should be provided by bottomsheet portals to cleanup the state. */
    /* eslint-disable-next-line @typescript-eslint/no-explicit-any --
     * See aka.ms/mini-lint-errors
     *	> Unexpected any. Specify a different type. */
    onOverlayClick?: (ev?: React.MouseEvent<any>) => void;
    /** Callback to invoke once the exit transition has played out and the component is unmounted. */
    onUnmounted?: () => void;
    /* eslint-disable-next-line @typescript-eslint/no-explicit-any --
     * See aka.ms/mini-lint-errors
     *	> Unexpected any. Specify a different type. */
    elementToFocusOnOpen?: React.RefObject<any>;
    /* eslint-disable-next-line @typescript-eslint/no-explicit-any --
     * See aka.ms/mini-lint-errors
     *	> Unexpected any. Specify a different type. */
    elementToFocusOnClose?: React.RefObject<any>;
    addAccessibleCloseButton?: boolean;
    /** Do not apply safe area padding to bottom sheet content if true */
    noSafeArea?: boolean;
    /** Styles for drag element */
    draggableElementStyles?: string;
    /** State of the bottomsheet */
    bottomSheetBehavior?: BottomSheetBehavior;
}

export interface BottomSheetAnimatedWrapperProps extends BottomSheetAnimatedProps {
    isScrollable?: boolean;
    // Base url path of the bottomsheet route
    basePath?: string;
}

export interface BottomSheetAnimatedStatefulProps extends BottomSheetAnimatedWrapperProps {
    hideOnOverlayClick?: boolean;
}

export interface BottomSheetBehavior {
    expandState: BottomSheetExpandState;
}

export enum BottomSheetExpandState {
    FitContent,
    Full,
}
